import { KiteSelect, KiteTextInput } from '@kite/react-kite';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { QuizCardInputs } from './QuizCardsInput';

export const QuizCard4 = (props: QuizCardInputs) => {
    const [otherSelected, setOtherSelected] = useState(false);
    const [otherValue, setOtherValue] = useState(``);
    const data = useStaticQuery(graphql`
        query {
            allNodeIndustryPage {
                nodes {
                    title
                }
            }
        }
    `);

    if (!data) return <></>;

    const { nodes } = data.allNodeIndustryPage;
    const titles = nodes.map((node) => node.title).sort();
    const me = props.config[props.idx];

    const onChange = (evt?) => {
        const val = evt?.target?.value;
        if (val.noCheck || val === `Other`) {
            if (!val.noCheck) setOtherSelected(true);
            me.value.industry = otherValue;
            me.valid = !!otherValue;
        } else {
            setOtherSelected(false);
            me.value.industry = val;
            me.valid = true;
        }
        props.setConfig([...props.config]);
    };

    useEffect(() => {
        onChange({ target: { value: { noCheck: true } } });
    }, [otherValue]);

    return (
        <>
            <KiteSelect
                label=""
                name="industry"
                id="industry"
                onChange={onChange}
                value={otherSelected ? `Other` : (me.value.industry as string)}
                disabled={!props.viewable}
            >
                <option value="" disabled>
                    - Select -
                </option>
                {titles.map((title, idx) => (
                    <option value={title} key={idx}>
                        {title}
                    </option>
                ))}
                <option value="Other">Other</option>
            </KiteSelect>
            {otherSelected && (
                <KiteTextInput
                    onChange={(evt) => setOtherValue(evt.target.value)}
                    label="Enter your industry:"
                    placeholder="Industry Type"
                    value={otherValue}
                    disabled={!props.viewable}
                />
            )}
        </>
    );
};
